import { useEffect, useState } from 'react'

const DISMISS_KEY = 'arise-pwa-dismissed'

export default function InstallPrompt() {
  const [evt, setEvt]     = useState(null)
  const [show, setShow]   = useState(false)
  const [iosHint, setIos] = useState(false)

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) return  // already installed
    if (localStorage.getItem(DISMISS_KEY)) return                        // user dismissed

    const ua = navigator.userAgent.toLowerCase()
    const isIos = /iphone|ipad|ipod/.test(ua) && !/crios|fxios/.test(ua)
    if (isIos) {
      setIos(true)
      setTimeout(() => setShow(true), 4000)
      return
    }

    const onPrompt = (e) => {
      e.preventDefault()
      setEvt(e)
      setShow(true)
    }
    window.addEventListener('beforeinstallprompt', onPrompt)
    return () => window.removeEventListener('beforeinstallprompt', onPrompt)
  }, [])

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, String(Date.now()))
    setShow(false)
  }

  async function install() {
    if (!evt) return
    evt.prompt()
    const choice = await evt.userChoice
    if (choice.outcome === 'accepted') dismiss()
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="fixed bottom-24 md:bottom-6 left-4 md:left-auto md:right-6 z-40 max-w-sm border border-card bg-card rounded-themed p-4 shadow-themed animate-system-open">
      <div className="flex items-start gap-3">
        <img src="/icon-192.png" alt="" className="w-10 h-10 rounded-themed flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-display text-sm">Arise installieren</div>
          {iosHint ? (
            <div className="text-xs opacity-70 mt-1">
              Safari → <b>Teilen</b> → <b>Zum Home-Bildschirm</b>. App fühlt sich nativ an.
            </div>
          ) : (
            <div className="text-xs opacity-70 mt-1">
              Als App auf dem Home-Bildschirm — schneller Start, offline-fähig.
            </div>
          )}
          <div className="flex gap-2 mt-2">
            {evt && (
              <button onClick={install} className="text-xs px-3 py-1.5 rounded-themed bg-accent font-semibold">
                Installieren
              </button>
            )}
            <button onClick={dismiss} className="text-xs px-3 py-1.5 rounded-themed border border-card opacity-70 hover:opacity-100">
              Später
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
